import styled from "styled-components";

export const JitsiMeet  = styled.div`
    div:first-child
    {
        height: 400px !important;
    } 

    div:first-child iframe #document html
    {
        display: none !important;
    }
`

